const geo = {
  lang: "geo",
  home: "მთავარი",
  welcomeText:
    "გამარჯობა მე ვარ ლუკა როსტომაშვილი, გთავაზობთ იურიდიულ, ესპანური ენის, ამერიკის ვიზის, მართვის მოწმობის და თარჯიმნის სერვისს",
  services: "სერვისები",
  lawyer: "ადვოკატი",
  academy: "ლუკას აკადემია",
  visa: "ამერიკის ვიზის სრული სერვისი",
  driver: "მართვის მოწმობაში მომზადება(სრული კურსი)",
  translate: "თარჯიმნის სერვისი",
  aboutMe: "ჩემს შესახებ",
  aboutMeText:
    "გამარჯობა მე ვარ ლუკა როსტომაშვილი, იურისტი და სამართალმცოდნე, ესპანეთის ახალგაზრდა ელჩი და ესპანური ენის სპეციალისტი. ასევე დამატებით მაქვს ჩემი 'ლუკას აკადემია' სადაც ვთავაზობთ, როგორც უცხო ენების ასევე მართვის მოწმობის კურსებს და ბოლოს ამერიკის ვიზის სრულ სერვისს ლეგალურად",
  education: "განათლება",
  educationText:
    "მე მივიღე განათლება ბარსელონას უნივერსიტეტში და ალიკანტეს უნივერსიტეტში, ასევე გაცვლითი პროგრამით ვიყავი მადრიდის კომპუტენსეს უნივერსიტეტში იურიდიულ ფაკულტეტზე 3 თვის განმავლობაში. გარდა ამისა ვფლობ ევროკავშირის საერთაშორისო დიპლომს რის საფუძველზეც 3 თვის განმავლობაში ვიყავი ესპანეთის ახალგაზრდა ელჩი რაც ისტორიული მოვლენაა",
  achievement: "მიღწევები",
  contact: "კონტაქტი",
  recomendations: "რეკომენდაცია",
  recomendation_one:
    "მადლობა ლუკას მხარდაჭერისთვის ის ნამდვილად კარგი ადამიანია",
  recomendation_two:
    "მადლობა ლუკას მხარდაჭერისთვის, ინფორმაციის მოწოდებისთვის ის ნამდვილი პროფესიონალია. მას სრულ რეკომენდაციას ვუწევ",
};

export default geo;
